import type { Article } from '@/mocks/articles';

interface ArticleContentProps {
  article: Article;
}

export default function ArticleContent({ article }: ArticleContentProps) {
  return (
    <section className="w-full bg-background-100 py-12 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          <div className="lg:w-2/5">
            <p className="text-xs text-foreground-500 font-medium mb-3 tracking-wide uppercase">
              文章 · {article.category}
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              {article.title.split('，')[0]}
            </h2>
            <p className="mt-3 text-foreground-500 text-sm leading-relaxed">
              {article.excerpt}
            </p>
          </div>

          <div className="lg:w-3/5 flex gap-4">
            <div className="w-2/5 rounded-2xl overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.imageAlt}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-3/5 rounded-2xl overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.imageAlt}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 max-w-3xl mx-auto">
          <article
            className="prose-custom text-foreground-700 leading-relaxed text-sm md:text-base space-y-4"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          <div className="mt-10 flex flex-wrap gap-2">
            {article.tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 rounded-full bg-background-200/70 text-foreground-600 text-xs font-medium"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}